<template>
  <div class="col-md-4 col-sm-6 col-xs-12 p-y">
    <a class="container--center">
      <div v-on:click="goMember(member.alias)" class="m-r">
        <lazy-img class="img-rounded" :src="image"></lazy-img>
        <i class="on b-white bottom"></i>
      </div>
      <div>
        <div v-on:click="goMember(member.alias)" class="member-name">{{member.name}}</div>
        <div v-on:click="goMember(member.alias)" class="block text-muted text-sm">
          <span class="pull-left member-title">{{member.title}}</span>
        </div>
        <br />
        <div
          v-on:click="goMember(member.alias)"
          v-if="member.location.country_id"
          class="member-location"
        >
          <i class="fa fa-map-marker icon"></i>
          <span v-if="member.location.city">{{member.location.city}}</span>
          <span class="text-u-c">{{ getCountryName(member.location.country_id) }}</span>
        </div>
        <div v-if="isOwner" class="remove-member" :id="member.profile_id">
          <i class="fa fa-trash"></i> remove
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { loadImage } from "@src/helpers/image-helper";

export default {
  name: "member",
  data() {
    return {
      image: null
    };
  },
  props: {
    member: null,
    isOwner: false
  },
  watch: {
    member: function(to) {
      this.member = to;
      loadImage(this.member.thumbs["thumb"], 'https://ukuyacommunity.s3.amazonaws.com/system/profile_default.jpg', null, src => {
        this.image = src;
      });
    },
    isOwner: function(to) {
      this.isOwner = to;
    }
  },
  mounted() {
    loadImage(this.member.thumbs["thumb"], 'https://ukuyacommunity.s3.amazonaws.com/system/profile_default.jpg', null, src => {
      this.image = src;
    });
  },
  computed: {
    ...mapGetters(["getCountryName"])
  },
  methods: {
    goMember(id) {
      window.location.assign(
        `${window.user.community_url}/${window.user.community_domain}/default/profiles/view/${id}`
      );
    }
  }
};
</script>

<style lang="scss">
.lazy-image-placeholder {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto;
}
.lazy-image {
  max-width: 100% !important;
}
</style>
<style scoped >
.img-rounded {
  width: 100px;
  height: 100px;
  border-radius: 100%;
}
.member-name {
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #393939;
  max-width: 180px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.member-title {
  font-weight: 300;
  font-size: 13px;
  line-height: 15px;
  color: #888888;
  max-width: 180px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.member-location {
  margin-bottom: 8px;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #888888;
}
.remove-member {
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #888888;
}
@media only screen and (max-width: 1200px) and (min-width: 1024px) {
  .member-name {
    max-width: 120px;
  }
}
@media only screen and (max-width: 1023px) and (min-width: 768px) {
  .member-name {
    max-width: 100px;
  }
}
</style>
